import { makeObservable, override } from 'mobx';

import { IGroupData } from 'APP/model/group/groupModel.types';
import { Root } from 'STORE';
import { Groups } from 'STORE/Groups/Groups';

import { Group } from '../Group';

export class Channel extends Group {
  constructor(group: IGroupData, groups: Groups, root: Root) {
    super(group, groups, root);
    makeObservable(this);
  }

  get isChannel(): boolean {
    return true;
  }

  @override
  get canInviteUsers(): boolean {
    return this.withMeInAdmins;
  }

  get canMentionAll(): boolean {
    return false;
  }

  get canBeScheduled(): boolean {
    return true;
  }
}
